import React, {useEffect, useState} from "react";
import WogComponent from "../../AppLocals/WoG/WogComponent";
import classNames from "classnames";

export const GodWordsBlock = React.memo(({style = {}}) => {
    const [autoHeight, setAutoHeight] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setAutoHeight(false)
        }, 500)

        return () => clearTimeout(timer)   // cleanup khi unmount
    }, [])

    return (
        <div
            className={classNames("p-4 w-full flex flex-col flex-center",
                autoHeight ? "shadow-block rounded-4xl h-48" : "shadow-block rounded-4xl min-h-48"
            )}
            style={{
                background: `linear-gradient(135deg, #818cf8 0%, #67e8f9 100%)`,
                fontFamily: "'Montserrat', sans-serif",
                ...style
            }}>
            <WogComponent today={1}/>
        </div>
    )
})
